<main style="background: #ffffff" style="min-height: calc(100vh - 60px)">
  <div class="d-flex flex-column justify-content-center py-5">
    <div class="container py-5">
      <div class="col-lg-10 mx-auto py-3">
        <div class="d-flex flex-column gap-3 w-100">
          <!-- Header -->
          <div class="row gap-3">
            <div class="col-sm">
              <div class="">
                <h4 class="mb-0">Les publicités foncières</h4>
              </div>
            </div>
            <div class="col-sm-auto">
              <div class="d-flex flex-wrap justify-content-end">
                <form
                  class="d-flex flex-fill mb-2 position-relative"
                  role="search"
                  (submit)="$event.preventDefault()"
                  style="min-width: 320px"
                >
                  <div class="input-group position-relative" style="width: 100%">
                    <div
                      class="form-control rounded-end-0 d-flex align-items-center gap-2 flex-wrap"
                      style="min-height: 38px"
                    >
                      <!-- Badge pour l'élément sélectionné -->
                      <span
                        *ngIf="selectedItem"
                        class="badge bg-primary d-flex align-items-center gap-2 py-1 px-2 badge-selected"
                      >
                        <span class="style_semiBold" style="font-size: 0.85em">{{
                          selectedItem.name
                        }}</span>
                        <button
                          type="button"
                          class="btn-close btn-close-white flex-shrink-0"
                          style="font-size: 0.6em; padding: 0; width: 12px; height: 12px"
                          (click)="removeSelectedItem($event)"
                          aria-label="Supprimer"
                        ></button>
                      </span>
                      <!-- Input de recherche -->
                      <input
                        *ngIf="!selectedItem"
                        class="border-0 flex-grow-1"
                        type="search"
                        placeholder="Rechercher par quartier/village"
                        aria-label="Search"
                        aria-describedby="button-addon1"
                        [(ngModel)]="keyword"
                        name="search"
                        (input)="onSearchInput($any($event.target).value)"
                        (focus)="onSearchFocus()"
                        (blur)="onSearchBlur()"
                        style="outline: none; min-width: 250px"
                      />
                    </div>
                  </div>
                  <!-- Dropdown contextuel -->
                  <div
                    *ngIf="showSearchDropdown && !selectedItem"
                    class="position-absolute bg-white border rounded-2 shadow-sm mt-1 p-2 search-dropdown"
                    style="
                      top: 100%;
                      left: 0;
                      width: 100%;
                      z-index: 1000;
                      max-height: 400px;
                      overflow-y: auto;
                    "
                    (scroll)="onDropdownScroll($event)"
                  >
                    <div class="list-group p-0">
                      <a
                        *ngFor="let quartier of quartiers"
                        href="#"
                        class="rounded-2 list-group-item list-group-item-action border-0 px-3 py-2"
                        (click)="selectItem(quartier, $event)"
                      >
                        <div class="d-flex flex-column">
                          <p class="my-0 style_semiBold">{{ quartier.name }}</p>
                          <p class="style_font_size_small mb-0 text-muted">
                            {{ quartier.department }} - {{ quartier.commune }} -
                            {{ quartier.arrondissement }}
                          </p>
                        </div>
                      </a>
                      <!-- Loader pour le chargement -->
                      <div *ngIf="loadingQuartiers" class="text-center py-2">
                        <div class="spinner-border spinner-border-sm text-primary" role="status">
                          <span class="visually-hidden">Chargement...</span>
                        </div>
                      </div>
                      <!-- Message si aucun quartier -->
                      <div
                        *ngIf="!loadingQuartiers && quartiers.length === 0"
                        class="text-center py-3 text-muted"
                      >
                        <small>Aucun quartier trouvé</small>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <!-- Publications list -->
          <div class="d-flex flex-column gap-2 w-100">
            <ng-template #empty>
              <app-state-section
                [state]="'empty'"
                [message]="'PUB_NO_DATA' | translate"
              ></app-state-section>
            </ng-template>
            <ng-template #loader>
              <div class="text-center my-5">
                <div
                  class="spinner-border text-primary"
                  style="width: 3rem; height: 3rem"
                  role="status"
                >
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            </ng-template>
            <ng-container #data *ngIf="!state.loading; else loader">
              <app-state-section
                *ngIf="state.error; else publicationList"
                [state]="'error'"
                [message]="state.error"
              ></app-state-section>
              <ng-template #publicationList>
                <div
                  *ngIf="publications && publications.length > 0; else empty"
                  class="d-flex flex-column gap-4"
                >
                  <div
                    *ngFor="let publication of publications"
                    class="border-bottom border-dark border-opacity-25 w-100 text-center text-sm-start d-flex p-4"
                  >
                    <div
                      class="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-sm-start align-items-center w-100"
                    >
                      <div
                        style="width: 90px; height: 90px"
                        class="d-flex flex-column text-center rounded-3 justify-content-center align-items-center bg-success text-white"
                      >
                        <ng-container
                          *ngIf="
                            (publication.dateFin ?? (publication.dateDebut | addDays: 15)
                              | remainingDays) > 0;
                            else expired
                          "
                        >
                          <p class="mb-0 style_font_size_small">RESTE :</p>
                          <h3 class="mb-0 style_bold" style="line-height: 100%">
                            {{
                              publication.dateFin ?? (publication.dateDebut | addDays: 15)
                                | remainingDays
                            }}
                          </h3>
                          <p class="mb-0 style_font_size_small">Jour(s)</p>
                        </ng-container>
                        <ng-template #expired>
                          <h1 class="mb-0 display-1" style="line-height: 100%">
                            <i class="bi-check"></i>
                          </h1>
                        </ng-template>
                      </div>
                      <div
                        class="d-flex flex-column flex-sm-row justify-content-sm-between gap-3 justify-content-center align-items-center align-items-sm-start flex-fill"
                      >
                        <div
                          class="d-flex gap-1 flex-column align-items-center align-items-sm-start"
                        >
                          <p class="mb-0 text-dark text-opacity-50">
                            <i class="bi-geo-alt text-danger me-1"></i>
                            {{ publication.quartierParcelle }},&nbsp;
                            {{ publication.arrondissementParcelle }},&nbsp;
                            {{ publication.communeParcelle }}
                          </p>
                          <h4 class="mb-0 style_normal">NUP : {{ publication.nup }}</h4>
                          <p class="mb-0">{{ publication.proprietaire }}</p>
                        </div>
                        <div
                          class="d-flex gap-1 flex-column align-items-center align-items-sm-start"
                          style="min-width: 160px;"
                        >
                          <p class="mb-0 text-dark text-opacity-50">
                            <i class="bi-fullscreen text-danger me-1"></i>Superficie
                          </p>
                          <h4 class="mb-0 style_normal">
                            {{ publication.superficie | number:'1.2-2' }} <small>m²</small>
                          </h4>
                          <button
                            class="btn btn-danger"
                            [disabled]="((publication.dateFin ?? (publication.dateDebut | addDays: 15)) | remainingDays) <= 0"
                            [attr.aria-disabled]="((publication.dateFin ?? (publication.dateDebut | addDays: 15)) | remainingDays) <= 0"
                            [attr.title]="((publication.dateFin ?? (publication.dateDebut | addDays: 15)) | remainingDays) <= 0 ? 'Publication clôturée' : 'M\'opposer'"
                          >
                            M'opposer
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-container>
          </div>
          <!-- Pagination -->
          <div *ngIf="paginationData" class="mt-4">
            <app-pagination
              *ngIf="!state.loading && !state.error && publications && publications.length > 0"
              [paginationData]="paginationData"
              (onPageConfigsChange)="reloadPublications($event)"
            ></app-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
